import { Link } from "react-router-dom";

export default function HotCard({ className, data, showContent = true }) {
  return (
    <Link
      to={`/ho-detail/${data.id}`}
      onClick={() => window.scrollTo(0)}
      className={`w-full flex flex-col bg-white  ${
        showContent ? "shadow-hotCard" : ""
      } ${className}`}
    >
      <div className="w-full h-[195px] md:h-[250px] lg:h-[380px] relative">
        <div
          className="bgImage"
          style={{ backgroundImage: `url(${data.image})` }}
        />
      </div>

      <div
        className={`py-10 px-5 bg-white flex-col gap-5 ${
          showContent ? "flex" : "hidden lg:flex"
        }`}
      >
        <div className="text-[20px] leading-6 font-semibold text-black">
          {data.title}
        </div>
        <div className="text-base text-black leading-5">{data.duration}</div>
        <div className="text-2xl font-regular text-black">
          <span className="font-bold">RM ${data.discountRm}</span>{" "}
          <strike className="text-base">RM {data.originalRm}</strike>
        </div>
      </div>
    </Link>
  );
}
